<template>
  <div id="sum" style="display: flex">
    <div id="aside">
      <el-button
        type="primary"
        id="newButton"
        icon="el-icon-plus"
        @click="linkCreate"
      >
        <span style="font-weight: bold; font-size: 16px">New</span>
      </el-button>
      <el-col :span="12" id="list">
        <el-menu
          id="item"
          default-active="7"
          class="el-menu-vertical-demo"
          @select="handleSelect"
        >
          <el-menu-item index="1">
            <i class="el-icon-document"></i>
            <span slot="title">All Questionnaire</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-document"></i>
            <span slot="title">All Industry</span>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="el-icon-document"></i>
            <span slot="title">All Company Type</span>
          </el-menu-item>
          <el-menu-item index="7">
            <i class="el-icon-document"></i>
            <span slot="title">All Submissions</span>
          </el-menu-item>
          <el-menu-item index="5">
            <i class="el-icon-setting"></i>
            <span slot="title">Set Used Questionnaire</span>
          </el-menu-item>
          <el-menu-item index="6">
            <i class="el-icon-setting"></i>
            <span slot="title">Manage User License</span>
          </el-menu-item>
          <el-menu-item index="8">
            <i class="el-icon-setting"></i>
            <span slot="title">Add New User</span>
          </el-menu-item>
          <el-menu-item index="9">
            <i class="el-icon-setting"></i>
            <span slot="title">Add New Consultant</span>
          </el-menu-item>
          <el-menu-item index="10">
            <i class="el-icon-setting"></i>
            <span slot="title">Manage Prompts</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </div>
    <div id="mainpage">
      <div id="title">
        <span style="margin-left: 35px">All Submissions</span>
        <div style="float: right; margin-right: 35px">
          <el-button
            v-if="hasActiveSearch"
            type="danger"
            icon="el-icon-refresh-left"
            @click="clearSearch"
            style="margin-right: 10px"
          >
            Clear Search
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchDialogVisible = true"
          >
            Search
          </el-button>
        </div>
      </div>

      <div id="main-body">
        <div>
          <el-card
            v-for="(msg, index) in userdata"
            class="box-card"
            :key="index"
            :body-style="{ padding: '0px 25px' }"
          >
            <div slot="header" style="display: flex">
              <el-row>
                <el-col
                  :span="20"
                  style="font-weight: bold; color: #409eff; font-size: 16px"
                >
                  Case Name:
                  {{
                    msg.config && msg.config.case_name
                      ? msg.config.case_name
                      : "N/A"
                  }}
                </el-col>
                <el-col
                  :span="20"
                  style="font-weight: bold; color: #409eff; font-size: 16px"
                >
                  Lead Contact:
                  {{
                    msg.config && msg.config.lead_contact
                      ? msg.config.lead_contact
                      : "N/A"
                  }}
                </el-col>
                <el-col :span="20">Submission Id: {{ msg.title }}</el-col>
                <el-col :span="20">Industry: {{ msg.industry_name }}</el-col>
                <el-col :span="20"
                  >Company Type: {{ msg.company_type_name }}</el-col
                >
                <el-col :span="20"
                  >Questionnaire ID: {{ msg.fk_questionnaire_id }}</el-col
                >
                <el-col :span="20">User Email: {{ msg.user_email }}</el-col>
                <el-col :span="20">State: {{ msg.state }}</el-col>
                <el-col :span="20">Report State: {{ msg.report_state }}</el-col>
                <el-col :span="20"
                  >Report State New: {{ msg.report_state_new }}</el-col
                >
                <el-col :span="20">Case ID: {{ msg.case_id }}</el-col>
                <el-col :span="20"
                  >Case ID Public: {{ msg.case_id_public }}</el-col
                >
              </el-row>
              <span class="headspan">Create_Time: {{ msg.create_time }}</span>
              <span class="headspan">Update_Time: {{ msg.update_time }}</span>
            </div>
            <div slot="default" class="card-body">
              <el-button
                type="text"
                class="rightside el-icon-receiving"
                @click="resubmit(msg.title)"
                >&nbsp;Re-Submit</el-button
              >
              <el-button
                type="text"
                class="rightside el-icon-document"
                @click="checkLog(msg.title)"
                >&nbsp;Check Log</el-button
              >
              <el-button
                type="text"
                class="rightside el-icon-document"
                @click="uploadFile(msg.title)"
                >&nbsp; Upload Full Report Data</el-button
              >
              <el-button
                v-show="msg.report_state == 'finished'"
                type="text"
                class="rightside el-icon-document"
                @click="openReportLanguageDialog(msg)"
                >&nbsp; Check Report</el-button
              >
              <el-button
                v-show="msg.report_state == 'finished'"
                type="text"
                class="rightside el-icon-document"
                @click="openEditReportContenteDialog(msg)"
                >&nbsp; Edit Report Content</el-button
              >
              <el-button
                type="text"
                class="rightside el-icon-document"
                @click="editUserInput(msg)"
                >&nbsp; Edit User Input</el-button
              >
              <el-button
                @click="download_report(msg)"
                :loading="downloadingItems['1_' + msg.title]"
                icon="el-icon-download"
                :disabled="downloadingItems['1_' + msg.title]"
              >
                <span v-if="downloadingItems['1_' + msg.title]">Downloading...</span>
                <a v-else href="#" style="text-decoration: none; color: inherit"
                  >Report</a
                >
              </el-button>
              <el-button
                @click="download_certificate(msg)"
                :loading="downloadingItems['2_' + msg.title]"
                icon="el-icon-download"
                :disabled="downloadingItems['2_' + msg.title]"
              >
                <span v-if="downloadingItems['2_' + msg.title]">Downloading...</span>
                <a v-else href="#" style="text-decoration: none; color: inherit"
                  >Certificate</a
                >
              </el-button>
              <input
                @change="(event) => fileInput(event, msg)"
                type="file"
                accept=".xlsx"
                id="fileInput"
                style="display: none"
              />
            </div>
          </el-card>

          <el-pagination
            layout="sizes, prev, pager, next, jumper"
            background
            :current-page="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin: 20px"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
        title="Report Setting"
        :visible.sync="reportSettingDialogVisible"
        width="30%"
      >
        <el-form :model="reportSettingDialogForm" ref="reportSettingDialogForm">
          <el-form-item
            label="Currency Unit"
            label-width="120px"
            prop="currency"
          >
            <el-select
              v-model="reportSettingDialogForm.currency"
              placeholder=""
              filterable
            >
              <el-option label="CNY" value="CNY"></el-option>
              <el-option label="USD" value="USD"></el-option>
              <el-option label="GBP" value="GBP"></el-option>
              <el-option label="EUR" value="EUR"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="language" label-width="120px" prop="language">
            <el-select
              v-model="reportSettingDialogForm.language"
              placeholder="Please select language"
              filterable
            >
              <el-option label="Chinese" value="zh"></el-option>
              <el-option label="English" value="en"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="reportSettingDialogVisible = false"
            >Cancel</el-button
          >
          <el-button
            type="primary"
            @click="
              confirmReportSetting(
                currentSubmissionId,
                reportSettingDialogForm.language,
                reportSettingDialogForm.currency
              )
            "
            >Confirm</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="Edit Report Content"
        :visible.sync="editReportContentDialogVisible"
        width="80%"
      >
        <vue-json-editor
          v-model="currentSubmissionObj"
          :options="editorOptions"
        ></vue-json-editor>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editReportContentDialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="editReportContentDialogConfirm"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <SubmissionsReview
        v-if="reviewDialogVisible"
        :user_inputs="user_inputs"
        :lang="lang"
        :report_currency="report_currency"
        :currency="questionnaire_currency"
        :chat_log_description="chat_log_description"
        @close="handleClose"
        @submit="handleSubmit"
      />

      <!-- Search Dialog -->
      <el-dialog
        title="Search Submissions"
        :visible.sync="searchDialogVisible"
        width="50%"
        :before-close="handleSearchDialogClose"
        class="search-dialog"
      >
        <div class="search-form-container">
          <el-form :model="searchForm" label-width="140px">
            <el-form-item label="Submission ID">
              <el-input
                v-model="searchForm.submission_id"
                placeholder="Enter submission ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="Questionnaire ID">
              <el-input
                v-model="searchForm.questionnaire_id"
                placeholder="Enter questionnaire ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="Case ID">
              <el-input
                v-model="searchForm.case_id"
                placeholder="Enter case ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="Public ID">
              <el-input
                v-model="searchForm.public_id"
                placeholder="Enter public ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="Industry ID">
              <el-input
                v-model="searchForm.industry_id"
                placeholder="Enter industry ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="Company Type ID">
              <el-input
                v-model="searchForm.company_type_id"
                placeholder="Enter company type ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="User ID">
              <el-input
                v-model="searchForm.user_id"
                placeholder="Enter user ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="Email">
              <el-input
                v-model="searchForm.email"
                placeholder="Enter email"
              ></el-input>
            </el-form-item>
            <el-form-item label="Case Name">
              <el-input
                v-model="searchForm.case_name"
                placeholder="Enter case name"
              ></el-input>
            </el-form-item>
            <el-form-item label="Lead Contact">
              <el-input
                v-model="searchForm.lead_contact"
                placeholder="Enter lead contact"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleSearchDialogClose">Cancel</el-button>
          <el-button type="primary" @click="handleSearch">Search</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import SubmissionsReview from "./SubmissionsReview.vue";
import VueJsonEditor from "vue-json-editor";

export default {
  components: {
    VueJsonEditor,
    SubmissionsReview,
  },
  created() {
    this.searchQns(0);
  },
  data() {
    return {
      chat_log_description: {},
      total: 0,
      downloadingItems: {}, // 使用对象跟踪多个下载状态
      temp_sid: "",
      reviewDialogVisible: false,
      user_inputs: null,
      lang: "EN",
      report_currency: "USD",
      questionnaire_currency: "USD",
      editReportContentDialogVisible: false,
      currentCardId: null,
      currentSubmissionObj: null,
      editorOptions: {
        mode: "code", // 设置编辑模式，其他可选值比如 'tree', 'form'
        mainMenuBar: true,
        navigationBar: true,
        statusBar: true,
      },
      reportSettingDialogVisible: false,
      currentSubmissionId: "",
      reportSettingDialogForm: {
        currency: "GBP",
        language: "en",
      },
      submission_id: "",
      currentPage: 1,
      pageSize: 10,
      pageSizes: [5, 10, 15, 20],
      activeIdx: "7",

      qnKey: "",
      orderItem: "default",
      orderType: "default",
      hasQn: true,
      input: "",
      is_released: "default",
      is_collected: 0,
      qn_type: 0,
      QnList: [],
      // Search dialog properties
      searchDialogVisible: false,
      searchForm: {
        submission_id: "",
        questionnaire_id: "",
        case_id: "",
        public_id: "",
        industry_id: "",
        company_type_id: "",
        user_id: "",
        email: "",
        case_name: "",
        lead_contact: "",
      },
      currentSearchParams: {}, // Store current search parameters for pagination
    };
  },
  methods: {
    // 通用打开文件函数，处理报告和证书
    // 通用打开文件函数，处理报告和证书
    openFile(msg, type) {
      const fileTypes = {
        1: "报告",
        2: "证书",
      };
      const fileName = fileTypes[type];
      const downloadKey = `${type}_${msg.title}`;

      console.log(`打开${fileName}_${msg.title}`, msg);

      // 设置当前打开状态
      this.$set(this.downloadingItems, downloadKey, true);

      // 获取当前域名
      const currentHost = window.location.hostname;

      let baseUrl;
      if (currentHost.includes(".ai")) {
        baseUrl = currentHost.includes("test")
          ? "https://rdm.oxvalue.cn"
          : "https://rdm.oxvalue.cn";
      } else {
        baseUrl = "https://www.oxvalue.cn";
      }

      const fileUrl = `${baseUrl}/api/report_pdf/v0.1/get_file?type=${type}&submission_id=${msg.title}&source_host=${currentHost}`;

      // 在新标签页中打开文件
      window.open(fileUrl, "_blank");

      // 重置打开状态
      this.$set(this.downloadingItems, downloadKey, false);
    },

    // 报告下载封装函数
    download_report(msg) {
      this.openFile(msg, 1);
    },

    // 证书下载封装函数
    download_certificate(msg) {
      this.openFile(msg, 2);
    },
    handleSubmit(
      user_inputs,
      model_inputs,
      report_curr,
      new_chat_log_description
    ) {
      console.log(user_inputs);
      console.log(model_inputs);
      console.log(report_curr);

      this.$axios({
        method: "PUT",
        url: `${this.$apiBaseUrl}/question/v0.1/submission_admin/${this.temp_sid}/`,
        headers: {
          Authorization: window.localStorage.getItem("ova_admin_token"),
        },
        data: JSON.stringify({
          user_inputs: JSON.stringify(user_inputs),
          model_inputs: JSON.stringify(model_inputs),
          report_curr: report_curr,
          chat_log_description: JSON.stringify(new_chat_log_description),
        }),
      }).then((res) => {
        console.log(res);
        this.handleClose();
      });
    },
    handleClose() {
      this.reviewDialogVisible = false;
      // 销毁组件并且将这些参数设置为默认值。
      this.user_inputs = null;
      this.lang = "EN";
      this.report_currency = "USD";
      this.questionnaire_currency = "USD";
    },
    editUserInput(msg) {
      // 获取到msg--当前case的提交信息
      console.log(msg);
      this.temp_sid = msg.title;
      // 根据sid发api得到它的user_inputs对象，和语言lang 和其他需要的参数。
      this.$axios({
        method: "get",
        url: `${this.$apiBaseUrl}/question/v0.1/submission_admin/${msg.title}/`,
        headers: {
          Authorization: window.localStorage.getItem("ova_admin_token"),
        },
      }).then((res) => {
        console.log(res);
        // 设置review组件需要的参数
        this.user_inputs = JSON.parse(
          res.data.data.user_inputs
        ).company_information;
        this.lang = res.data.data.config.chat_log_description.language
          ? res.data.data.config.chat_log_description.language.toLocaleUpperCase()
          : "ZH";
        this.report_currency = res.data.data.config.report_currency;
        this.questionnaire_currency = res.data.data.config.currency;
        this.chat_log_description = res.data.data.config.chat_log_description;
        // 因为review组件是由v-if控制的，当它设置为true是，组件被创建。变成false时组件被销毁
        this.reviewDialogVisible = true;
      });
    },
    editReportContentDialogConfirm() {
      console.log(this.currentSubmissionObj);
      this.$axios({
        method: "PUT",
        url: `${this.$apiBaseUrl}/question/v0.1/submission_admin/${this.currentCardId}/`,
        headers: {
          Authorization: window.localStorage.getItem("ova_admin_token"),
        },
        data: JSON.stringify({
          charts: JSON.stringify(this.currentSubmissionObj.charts),
          result: JSON.stringify(this.currentSubmissionObj.result),
          result2: JSON.stringify(this.currentSubmissionObj.report_en),
          result2_zh: JSON.stringify(this.currentSubmissionObj.report_zh),
          report_full_en: JSON.stringify(
            this.currentSubmissionObj.report_full_en
          ),
          report_full_zh: JSON.stringify(
            this.currentSubmissionObj.report_full_zh
          ),
          report_currency: this.currentSubmissionObj.config.report_currency,
          consultant_name: this.currentSubmissionObj.config.applicant_name,
          stamp: this.currentSubmissionObj.config.stamp,
          is_locked: this.currentSubmissionObj.is_locked,
        }),
      }).then((res) => {
        console.log(res);
      });

      this.currentSubmissionObj = null;
      this.currentCardId = null;
      this.editReportContentDialogVisible = false;
    },
    openEditReportContenteDialog(msg) {
      console.log(msg);
      this.currentCardId = msg.title;
      this.$axios({
        method: "get",
        url: `${this.$apiBaseUrl}/question/v0.1/submission_admin/${msg.title}/`,
        headers: {
          Authorization: window.localStorage.getItem("ova_admin_token"),
        },
      }).then((res) => {
        console.log(res.data.data.config);
        let report_data = {
          config: {},
        };
        report_data.result = JSON.parse(res.data.data.result);
        report_data.report_en = JSON.parse(res.data.data.result2);
        report_data.report_zh = JSON.parse(res.data.data.result2_zh);
        report_data.report_full_en = res.data.data.report_full_en
          ? JSON.parse(res.data.data.report_full_en)
          : "";
        report_data.report_full_zh = res.data.data.report_full_zh
          ? JSON.parse(res.data.data.report_full_zh)
          : "";
        report_data.charts = JSON.parse(res.data.data.charts);
        report_data.config.report_currency =
          res.data.data.config.report_currency;
        report_data.config.consultant_name =
          res.data.data.config.consultant_name;
        report_data.config.stamp = res.data.data.config.stamp + "";
        report_data.is_locked = res.data.data.config.is_locked + "";

        this.currentSubmissionObj = report_data;
      });
      this.editReportContentDialogVisible = true;
    },
    openReportLanguageDialog(msg) {
      console.log(msg);
      this.currentSubmissionId = msg.title;
      this.reportSettingDialogForm.currency = msg.currency;
      this.reportSettingDialogVisible = true;
    },
    confirmReportSetting(id, language, currency) {
      let token = window.localStorage.getItem("ova_admin_token");
      if (language == "zh") {
        window.open(
          `${this.$ovaUrl}/report_new_zh.html?sid=${id}&curr=${currency}&mode=admin&token=${token}`
        );
      } else if (language == "en") {
        window.open(
          `${this.$ovaUrl}/report_new.html?sid=${id}&curr=${currency}&mode=admin&token=${token}`
        );
      }
      this.reportSettingDialogVisible = false;
    },
    uploadFile(id) {
      this.submission_id = id;
      document.getElementById("fileInput").click();
    },
    fileInput(e) {
      const file = e.target.files[0]; // 获取用户选择的文件
      console.log(file);
      console.log("用户选择了文件：", file.name);
      console.log(this.submission_id);

      const formData = new FormData();
      formData.append("file", file); // 'file' 是你的服务器期望的字段名

      this.$axios({
        method: "post",
        url: `${this.$apiBaseUrl}/question/v0.1/full_report_file/${this.submission_id}/ `,
        headers: {
          Authorization: window.localStorage.getItem("ova_admin_token"),
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then(function (response) {
          console.log(response);
          if (response.data.code == 200) {
            alert(`上传成功`);
          } else if (response.data.code == -1) {
            alert(`上传失败：` + response.data.error);
          }
        })
        .catch(function (error) {
          console.error("上传失败:", error);
        });
    },
    linkCreate() {
      this.$router.push("/create_ques");
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index;
    },
    handleSizeChange(val) {
      console.log(`${val} Each Page`);
      this.currentPage = 1; // 切换每页显示数量时重置为第一页
      this.pageSize = val;
      this.searchQns(0, this.currentSearchParams);
    },

    handleCurrentChange(val) {
      console.log(`Current Page: ${val}`);
      this.currentPage = val;
      this.searchQns(0, this.currentSearchParams);
    },
    beforeHandleCommand(index, format) {
      return {
        index: index,
        format: format,
      };
    },
    handleSelect(key) {
      this.activeIdx = key;
      switch (this.activeIdx) {
        case "1":
          this.$router.push("/index");
          break;
        case "2":
          this.$router.push("/industry");
          break;
        case "3":
          this.$router.push("/bin");
          break;
        case "4":
          this.$router.push("/company");
          break;
        case "5":
          this.$router.push("/used_questionnaire");
          break;
        case "6":
          this.$router.push("/user_license");
          break;
        case "7":
          this.$router.push("/submissions");
          // Clear search when staying on submissions page
          this.clearSearch();
          break;
        case "8":
          this.$router.push("/add_new_user");
          break;
        case "9":
          this.$router.push("/add_new_consultant");
          break;
        case "10":
          this.$router.push("/manage_prompts");
          break;
      }
    },
    searchQn() {
      this.qnKey = this.input;
      this.searchQns(1);
    },
    searchQns(tag, searchParams = {}) {
      console.log(tag);

      // Build query parameters
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
      };

      // Add search parameters if provided
      if (searchParams && Object.keys(searchParams).length > 0) {
        Object.assign(params, searchParams);
      }

      this.$axios({
        method: "get",
        url: `${this.$apiBaseUrl}/question/v0.1/submission_admin/`,
        headers: {
          Authorization: window.localStorage.getItem("ova_admin_token"),
        },
        params: params,
      })
        .then((res) => {
          if (res.data["code"] == 403) {
            this.$store.dispatch("clear");
            window.localStorage.removeItem("ova_admin_token");
            this.$router.push("/login");
            return;
          }
          this.QnList = [];
          let qlist = res.data["data"]["submission_list"];

          // 使用后端返回的总数量
          this.total = res.data["data"]["total"];
          console.log(qlist);

          for (let q in qlist) {
            let question = {
              title: qlist[q]["id"],
              survey_id: qlist[q]["id"],
              create_time: qlist[q]["create_time"],
              update_time: qlist[q]["update_time"],
              currency: qlist[q]["currency"],
              industry_name: qlist[q]["industry_name"],
              company_type_name: qlist[q]["company_type_name"],
              fk_questionnaire_id: qlist[q]["fk_questionnaire_id"],
              fk_user_id: qlist[q]["fk_user_id"],
              user_email: qlist[q]["user_email"],
              user_name: qlist[q]["user_name"],
              state: qlist[q]["state"],
              report_state: qlist[q]["report_state"],
              report_state_new: qlist[q]["report_state_new"],
              case_id: qlist[q]["case_id"],
              case_id_public: qlist[q]["case_id_public"],
              config: qlist[q]["config"],
            };
            this.QnList.push(question);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resubmit(index) {
      let post_data = {};
      this.$confirm(
        "<p>This will submit the original answers again, do you want to do this?</p>" +
          '<label><input type="checkbox" id="stablePromptCheckbox"> 是否使用不稳定prompts</label>',
        "提示",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          dangerouslyUseHTMLString: true,
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              const checkbox = document.getElementById("stablePromptCheckbox");
              post_data.stable_flag = (!checkbox.checked).toString();
            }
            done();
          },
        }
      )
        .then(() => {
          this.$axios({
            method: "POST",
            url: `${this.$apiBaseUrl}/question/v0.1/resubmission_admin/${index}/`,
            headers: {
              Authorization: window.localStorage.getItem("ova_admin_token"),
            },
            data: post_data,
          }).then((res) => {
            if (res.data.code == "200") {
              this.$message.success("Re-submitted successfully.");
            } else {
              this.$message.error(res.data.error);
            }
          });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    checkLog(index) {
      this.$router.push(`/log?sid=${index}`);
    },
    // Search dialog methods
    handleSearchDialogClose() {
      this.searchDialogVisible = false;
      // Reset form
      this.searchForm = {
        submission_id: "",
        questionnaire_id: "",
        case_id: "",
        public_id: "",
        industry_id: "",
        company_type_id: "",
        user_id: "",
        email: "",
        case_name: "",
        lead_contact: "",
      };
    },
    handleSearch() {
      // Collect non-empty search parameters
      const searchParams = {};
      Object.keys(this.searchForm).forEach((key) => {
        if (this.searchForm[key] && this.searchForm[key].trim() !== "") {
          searchParams[key] = this.searchForm[key].trim();
        }
      });

      // Store current search parameters for pagination
      this.currentSearchParams = searchParams;

      // Reset to first page when searching
      this.currentPage = 1;

      // Call search with parameters
      this.searchQns(0, searchParams);

      // Close dialog
      this.handleSearchDialogClose();
    },
    clearSearch() {
      // Clear search parameters and reload all data
      this.currentSearchParams = {};
      this.currentPage = 1;
      this.searchQns(0);
    },
  },
  computed: {
    is_CN() {
      // 根据域名判断语言
      const host = window.location.hostname;
      return host.includes(".cn");
    },
    userdata: function () {
      return this.QnList; // 直接返回API获取的数据
    },
    hasActiveSearch() {
      // Check if there are any active search parameters
      return Object.keys(this.currentSearchParams).length > 0;
    },
  },
};
</script>

<style scoped>
#sum {
  /*height: 1000px;*/
  width: 100%;
  min-width: 1200px;
  /* background-color: rgb(241, 241, 241); */
}
#aside {
  width: 340px;
  /* background-color: antiquewhite; */
  min-width: 325px;
}
#mainpage {
  width: 70%;
  /* background-color: aquamarine; */
  min-width: 850px;
}
#newButton {
  width: 60%;
  height: 50px;
  font-size: 15px;
  margin-top: 25px;
}
#list {
  width: 100%;
  margin-top: 25px;
}
#list .el-menu {
  width: 240px;
  margin: 0 54px;
}
#list .el-menu-item {
  height: 50px;
  font-size: 14px;
  text-align: center;
}

#title {
  height: 35px;
  font-size: 22px;
  text-align: left;
  margin: 15px;
  font-weight: bold;
}
.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 6px;
}
#title .el-input {
  width: 200px;
}
.right {
  float: right;
  margin: 0 15px;
  /* margin-top: 10px; */
  padding: 13px 0;
}

.box-card {
  margin: 25px 50px;
  width: 89%;
  height: auto;
  font-size: 12px;
}
.el-col-20 {
  text-align: left;
  font-size: 16px;
  padding: 5px 15px;
  width: 520px;
  /* font-weight: bold; */
}
.headspan {
  padding: 7px 7px;
}
.leftside {
  float: left;
  padding: 10px;
}
.rightside {
  float: right;
  padding: 10px;
  color: black;
  font-size: 14px;
}
#download {
  padding: 3px 10px 12px 10px;
}

#newButton {
  width: 240px;
  height: 56px;
}

.el-icon-my-star {
  background: url("/src/assets/icon/star.png") center no-repeat;
  background-size: cover;
  font-family: element-icons;
}
.el-icon-my-star:before {
  font-size: 13px;
  content: "66ff";
  visibility: hidden;
  font-family: element-icons, serif !important;
}

/* Search Dialog Styles */
.search-dialog .el-dialog__body {
  padding: 20px;
  max-height: 60vh;
  overflow: hidden;
}

.search-form-container {
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 10px;
}

.search-form-container::-webkit-scrollbar {
  width: 6px;
}

.search-form-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.search-form-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.search-form-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
,,,
